const apiUrl = process.env.REACT_APP_API_URL;

export const DeleteItem = async (id_dubte: number, aulaSel : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${aulaSel}/dubtes/${id_dubte}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: 'valor' }),
        });

        if (response.ok) {
            return true;
        }
    } catch (error) {
        console.log('Error al marcar el item:', error);
    }
};
